import * as React from 'react';
import * as autoBind from 'react-autobind';
import MyWindow from '../../types/MyWindow';

declare const window: MyWindow;

export default class Toast extends React.Component<ToastProps, {}> {
   timeoutId: number;

   constructor(props: ToastProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount() {
      const {onTimeout} = this.props;
      if (this.timeoutId) {
         window.clearTimeout(this.timeoutId);
      }
      this.timeoutId = window.setTimeout(onTimeout, 3000);
   }

   componentWillUnmount() {
      window.clearTimeout(this.timeoutId);
   }

   render() {
      const {text} = this.props;
      return (
         <div className="toast-container">
             <div className="toast">
                {text}
             </div>
         </div>
      );
   }
}

export interface ToastProps {
   text: string;
   onTimeout(): void;
}
